import { render, staticRenderFns } from "./ReporteImpuestosSearchDates.vue?vue&type=template&id=0ba878c9&"
import script from "./ReporteImpuestosSearchDates.vue?vue&type=script&lang=js&"
export * from "./ReporteImpuestosSearchDates.vue?vue&type=script&lang=js&"
import style0 from "./ReporteImpuestosSearchDates.vue?vue&type=style&index=0&id=0ba878c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports